/* eslint-env browser, jquery */
/* global metricsLib */
import 'babel-polyfill';
import page from 'page';
import { handleQueryString as contactForm } from 'auth0-contact-form';
import localeRedirectionMiddleware from 'modules/locale-redirection';
import ab from 'modules/ab-testing';
import metrics from 'modules/metrics';
import { ie } from 'modules/npm-component/user-agent';
import bus from 'modules/npm-component/bus';
import triggers from 'modules/triggers';
import 'bootstrap';
import abVariants from 'pages/ab-variants';
import 'modules/canonical';
import 'modules/boot/sso';
import 'modules/header';
import 'modules/footer';
import homepage from 'pages/homepage';
import opensource from 'pages/opensource';
import dashboard from 'pages/dashboard';
import whyAuth0 from 'pages/why-auth0';
import pricing from 'pages/pricing';
import about from 'pages/about';
import customers from 'pages/customers';
import availabilityTrust from 'pages/availability-trust';
import terms from 'pages/terms';
import mcc from 'pages/mcc';
import privacy from 'pages/privacy';
import lock from 'pages/lock';
import changelog from 'pages/changelog';
import wordpress from 'pages/wordpress';
import blog from 'pages/blog';
import docs from 'pages/docs';
import press from 'pages/press';
import eventsLanding from 'pages/events-landing';
import security from 'pages/security';
import partners from 'pages/partners';
import passwordless from 'pages/passwordless';
import enterprise from 'pages/enterprise';
import guestAuthors from 'pages/guest-authors';
import breachedPasswords from 'pages/breached-passwords';
import guardian from 'pages/guardian';
import b2c from 'pages/b2c';
import b2b from 'pages/b2b';
import b2e from 'pages/b2e';
import b2bSaas from 'pages/b2b-saas';
import preferenceCenter from 'pages/preference-center';
import ambassadorProgram from 'pages/ambassador-program';
import signup from 'pages/signup';
import singleSignOn from 'pages/single-sign-on';
import jp from 'pages/jp';
import retail from 'pages/retail';
import appModernization from 'pages/app-modernization';
import gdpr from 'pages/gdpr';
import notfound from 'pages/notfound';
import legal from 'pages/legals/legal';
import allLegalFiles from 'pages/legals/all-legal-files';
import psaas from 'pages/legals/psaas';
import baa from 'pages/legals/baa';
import priorForms from 'pages/legals/prior-forms';
import ssTos from 'pages/legals/ss-tos';
import ssOq from 'pages/legals/ss-oq-collection-guidelines';
import baaEditable from 'pages/legals/baa-editable';
import dpa from 'pages/legals/dpa';
import dpaEditable from 'pages/legals/dpa-editable';
import editableSubscriptions from 'pages/legals/editable-subscriptions';
import financial from 'pages/financial-services';
import gdprAssessmentTool from 'pages/gdpr-assessment-tool';
import mediaPublishing from 'pages/media-publishing';
import tei from 'pages/tei';
import healthcare from 'pages/healthcare';
import travel from 'pages/travel';
import machineToMachine from 'pages/machine-to-machine';
import feedback from 'pages/feedback';
import universalLogin from 'pages/universal-login';

const config = window.APP_CONFIG;
// Important note: if you add new components for pages they should list before blog
const pages = [
  homepage,
  opensource,
  dashboard,
  whyAuth0,
  pricing,
  about,
  customers,
  availabilityTrust,
  terms,
  mcc,
  privacy,
  lock,
  changelog,
  wordpress,
  blog,
  docs,
  press,
  eventsLanding,
  security,
  partners,
  passwordless,
  enterprise,
  guestAuthors,
  breachedPasswords,
  guardian,
  b2c,
  b2b,
  b2e,
  b2bSaas,
  preferenceCenter,
  ambassadorProgram,
  signup,
  singleSignOn,
  jp,
  retail,
  legal,
  allLegalFiles,
  editableSubscriptions,
  baa,
  baaEditable,
  ssTos,
  ssOq,
  priorForms,
  dpa,
  dpaEditable,
  psaas,
  appModernization,
  feedback,
  gdprAssessmentTool,
  gdpr,
  mediaPublishing,
  financial,
  tei,
  healthcare,
  travel,
  machineToMachine,
  universalLogin
];

/**
 * Boot components
 * and pages.
 */

if (config.BASE_PATH_CLIENT) {
  page.base(config.BASE_PATH_CLIENT);
}

page(localeRedirectionMiddleware());

if (!config.disable_analytics) {
  page(ab.computeExperiments());
  // - AB testing variants should go here
  abVariants();

  // TODO: remove this code when links-developer-dropdown-menu-header experiment is finished
  window.abVariantHeader = '';
  ab.executeExperiment('links-developer-dropdown-menu-header-new', variant => {
    if (!variant) return;
    window.abVariantHeader = variant.name;
  });
}

// init pages
pages.forEach(pageItem => pageItem());
page('/jobs/(.*)?', replace());
page('/careers/(.*)?', replace());
page('/learn/(.*)?', replace());

page((ctx, next) => {
  const $ = window.$;
  // FIXME: this should be better handled in future iterations
  if (ctx.notFound) {
    next();
    return;
  }

  ctx.notFound = !!$('.notfound-page').length;
  next();
});

page((ctx, next) => {
  const metricsLib = window.metricsLib;
  if (ctx.querystring.indexOf('signup=true') > -1) {
    window.signup();
  }

  // Contact form
  const contactFormOptions = {
    onModalOpen() {},
    onFormSuccess(metricsData) {
      metricsLib.track('register:lead:pricing-contact-form', metricsData);
    },
    onFormFail(metricsData) {
      metricsLib.track('fail:register:lead:pricing-contact-form', metricsData);
    }
  };
  contactForm(contactFormOptions, { includePhoneField: true });
  return next();
});

page((ctx, next) => {
  const $ = window.$;
  if (window.location.hostname.toLowerCase() === 'auth0.com') {
    return next();
  }

  $('a[href^="https://auth0.com"]:not([rel="external"])').each(function replaceHref() {
    this.href = this.href.replace('https://auth0.com', '');
  });

  return next();
});

page(ab.executeExperiments());

// no page.js scripts should be
// added after `notfound`

notfound();

const scrollExceptionPages = ['/press/news', '/press/announcements', '/pricing', '/customers'];

// Initialize global events binded to page actions
bus.on('page:change', () => {
  const $ = window.$;
  const pathname = window.location.pathname;

  if (scrollExceptionPages.some(exception => pathname.indexOf(exception) !== -1)) return;
  $('body').scrollTop(0);
});

bus.on('page:render', () => {
  triggers.triggerNotSignedUp();
  metrics.onPageRenderEvent();
});

/**
 * Boot page.js
 */
const oldMsie = ie().lte(9);
page({
  click: !oldMsie
});

/**
 * Page.js middleware for path
 * replacing
 *
 * @param {String} path
 * @return {Function} middleware
 * @api private
 */

function replace(path) {
  return function middleware(ctx) {
    if (ctx.title.toLowerCase().indexOf('not found') === 0) {
      return;
    }

    const newPath = path || ctx.path;
    window.location.replace(newPath);
  };
}



// WEBPACK FOOTER //
// ./src/client.js